import gql from "../gql";
import Streak from "./Streak";
export default gql `
  fragment Streaks on LearnerStreakConnection {
    edges {
      node {
        ...Streak
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
  ${Streak}
`;
